import { render, staticRenderFns } from "./TrafficAssistant.vue?vue&type=template&id=76890642&scoped=true"
import script from "./TrafficAssistant.vue?vue&type=script&lang=js"
export * from "./TrafficAssistant.vue?vue&type=script&lang=js"
import style0 from "./TrafficAssistant.vue?vue&type=style&index=0&id=76890642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76890642",
  null
  
)

export default component.exports